export const initTasks = {
  items: [],
  todo: [],
  inProgress: [],
  done: [],
  isLoading: false,
  error: null,
};

